import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
import { fetchFibrePlans } from "../apiService";
import { PortalProduct } from "../Interface";

interface ExtendedProduct extends PortalProduct {
  available: boolean;
  activationFee?: string;
  monthlyPayment?: string;
  totalPayment?: string;
}

const Fibre = () => {
  const [plans, setPlans] = useState<ExtendedProduct[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadFibrePlans = async () => {
      try {
        const fetchedPlans = await fetchFibrePlans();
        setPlans(fetchedPlans);
        setLoading(false);
      } catch (err: any) {
        setError(err.message);
        setLoading(false);
      }
    };

    loadFibrePlans();
  }, []);

  const handleSignUp = (plan: ExtendedProduct) => {
    const encodedDetails = encodeURIComponent(JSON.stringify(plan));
    navigate(`/application-form-page?details=${encodedDetails}`);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container-fluid ">
      {/* Ensure the h2 element is properly rendered */}
      <h2 style={{ color: 'rgb(23, 37, 84)', textAlign: 'center', fontWeight: '700' }}>FIBRE PACKAGES</h2>
      <div className="content1">
        {plans.map((plan, index) => (
          <div key={index}>
            <div className="custom-card">
              <div className="custom-card-header">{plan.name}</div>
              <div className="custom-card-body">
                <h3 className="fw-bold" style={{ color: "#152455" }}>
                  {plan.currency} {plan.price}
                </h3>
                <ul className="list-unstyled" style={{ textAlign: "left" }}>
                  <li>Free Installation.</li>
                  <li>Free Router.</li>
                  <li>Free Connection.</li>
                  {plan.activationFee && <li>Activation Fee: {plan.activationFee}</li>}
                  {plan.monthlyPayment && <li>Monthly Payment: {plan.monthlyPayment}</li>}
                  {plan.totalPayment && <li>Total Payment: {plan.totalPayment}</li>}
                </ul>
              </div>
              <div className="custom-card-footer">
                {plan.available ? (
                  <button className="btn-orange" onClick={() => handleSignUp(plan)}>
                    SIGN UP NOW
                  </button>
                ) : (
                  <button className="btn-orange" disabled>
                    Out of Stock
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Fibre;
